module.exports = __webpack_public_path__ + "img/h3x.31b14511.svg";